module.exports = __webpack_public_path__ + "assets/img/jtfx42.7c4a5ca5.png";